import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./ComponentOverlay.module.css";

enum OverlayColor {
    Gandalf = "gandalf",
    Blue = "blue",
    Green = "green",
    Peach = "peach"
}

interface Props {
    class?: string;
    color: OverlayColor;
    children?: ComponentChildren;
    highlighted?: boolean;
    noBackground?: boolean;
    wrapParent?: boolean; // Make sure parent has `position: relative;`
}

function ComponentOverlay({
    class: cssClass,
    color,
    children,
    highlighted,
    noBackground,
    wrapParent
}: Props) {
    return (
        <div class={classname(styles.componentOverlay, cssClass, styles[color], {
            [styles.highlighted]: highlighted,
            [styles.wrapParent]: wrapParent,
            [styles.noBackground]: noBackground
        })}>
            {children}
        </div>
    );
}

export default ComponentOverlay;
export { OverlayColor };

